import { Controller } from "@hotwired/stimulus"
import { autocompleteSchool } from "../src/school_autocomplete"

export default class extends Controller {
  static values = { url: String }

  connect() {
    if (!window.$?.fn?.autocomplete || this.element.autocompleter) return

    autocompleteSchool(this.element, this.urlValue)
  }

  // The plugin appends its results to the body, where they would stay after a Turbo frame replaces the input.
  disconnect() {
    if (!this.element.isConnected) this.element.autocompleter?.results?.remove()
  }
}
